export type PresetBackground = {
  key: string;
  label: string;
  imageUrl: string;
};

// public/backgrounds/ 以下に画像ファイルを配置してください
export const PRESET_BACKGROUNDS: PresetBackground[] = [
  { key: 'bg1', label: '背景1', imageUrl: '/backgrounds/bg1.jpg' },
  { key: 'bg2', label: '背景2', imageUrl: '/backgrounds/bg2.jpg' },
  { key: 'bg3', label: '背景3', imageUrl: '/backgrounds/bg3.jpg' },
  { key: 'bg4', label: '背景4', imageUrl: '/backgrounds/bg4.jpg' },
];

export const isPresetBackground = (value: string): boolean =>
  PRESET_BACKGROUNDS.some((bg) => bg.imageUrl === value);
